/**
 *
 */
$(function() {
    /**
     * Create
     */
    $('#new-team-popup').on('click', '.create-team', function() {
        var form = $(this).closest('form');

        $.post(
            form.attr('action'),
            form.serialize(),
            function(response) {
                form.find('input').removeClass('error');
                form.find('label.error').text('');
                if (response.status == 'success') {
                    form.find('input[name=name]').val(null);

                    var teams = $(response.html);
                    teams.find('.chosen-select').chosen({});
                    teams.find('.change-avatar').each(function (k, v) {
                        init_team_avatar_edit($(v));
                    });
                    $('.teams-list').empty().append(teams);

                    info(response.message);

                    hidePopup();
                }
                else {
                    $.each(response.errors, function(k, v) {
                        form.find('[name=' + k + ']').addClass('error')
                            .closest('.form-field')
                            .find('label.error').text(v);
                    });
                }
            },
            'json'
        );

        return false;
    });

    /**
     *
     */
    var team_edit = function(url, form, team, is_delete) {
        $.post(
            url,
            form.serialize(),
            function(response) {
                info(response.message);

                if (response.status == 'error') {
                    return;
                }

                if (is_delete) {
                    team.remove();
                }
                else {
                    new_team = $(response.team);
                    new_team.find('.chosen-select').chosen({});
                    init_team_avatar_edit(new_team.find('.change-avatar'));
                    team.replaceWith(new_team);
                }
            },
            'json'
        );
    };

    /**
     * Dropdown actions
     */
    $('body').on('click', '.dropdown.team-settings .action', function() {
        var is_delete = $(this).hasClass('delete');
        if (is_delete && !window.confirm($(this).data('confirm'))) {
            $(this).closest('.dropdown').fadeOut();
            return false;
        }

        var form = $(this).closest('form');
        var team = $('#team-' + form.find('[name=id]').val());
        $(this).closest('.dropdown').fadeOut();

        team_edit($(this).attr('href'), form, team, is_delete);

        return false;
    });

    /**
     * Inline edits
     */
    $('.teams-list').on('click', '.button-save-action', function() {
        var btn = $(this);
        if (btn.hasClass('active')) {
            var form = $(this).closest('form');
            var team = $('#team-' + form.find('[name=id]').val());

            team_edit(form.attr('action'), form, team);

            return false;
        }
        else {
            btn.siblings('input, select').focus();
            return false;
        }
    })
    .on('click', '.button-cancel-action', function() {
        var btn = $(this);
        var form = btn.closest('form');
        btn.siblings('.button-save-action').removeClass('active').text('EDIT');
        btn.removeClass('active');

        if (form.hasClass('multiple')) {
            var select = btn.siblings('select[name=' + btn.data('input') + ']');

            select.find('option').prop('selected', false);

            if (btn.data('original-value')) {
                $.each(btn.data('original-value').split(','), function (k, v) {
                    select.find('option[value=' + v + ']').prop('selected', true);
                });
            }

            select.trigger('chosen:updated');
        }
        else {
            btn.siblings('input[name=' + btn.data('input') + ']').val(btn.data('original-value')).blur();
        }

        return false;
    })
    .on('focus', '.link input, .link select', function() {
        $(this).trigger('change');
    });

    /**
     * Invite set vars
     */
    $('body').on('click', '[data-popup="#team-invite-popup"]', function() {
        var popup = $('#team-invite-popup');

        popup.find('[name=id]').val($(this).data('team'));
        popup.find('.team-name').text($(this).data('name'));
    });

    /**
     * Invite
     */
    $('#team-invite-popup').on('click', '.invite', function() {
        var form = $(this).closest('form');

        $.post(
            form.attr('action'),
            form.serialize(),
            function(response) {
                form.find('input').removeClass('error');
                form.find('label.error').text('');
                if (response.status == 'success') {
                    form.find('input[name=email]').val(null);
                    info(response.message);
                    hidePopup();
                }
                else {
                    form.find('[name=email]').addClass('error').closest('.form-field').find('label.error').text(response.message);
                }
            },
            'json'
        );

        return false;
    });

    /**
     *
     */
    var init_team_avatar_edit = function(ca) {
        var avatar_error = ca.find('.avatar.error');

        ca.fileupload({
            url: ca.data('url'),
            dataType: 'json',
            done: function (e, data) {
                if (data.result.status == 'success') {
                    avatar_error.hide();
                    info(data.result.message);
                    ca.find('.userPicLarge')
                        .css('background-image', 'url(' + data.result.avatar + ')')
                        .css('font-size', 0);
                }
                else {
                    avatar_error.text(data.result.message).show();
                }
            }
        });
    };

    /**
     *
     */
    $('.teams-list .change-avatar').each(function (k, v) {
        init_team_avatar_edit($(v));
    });
});
